module.exports = __webpack_public_path__ + "static/media/sample2.ee7ac808.pdf";